import { ProductCardCrossSellingCreatorPrice } from "./ProductCardCrossSellingCreatorPrice";
import { ProductInstancePrice } from "./ProductInstancePrice";
export const ProductCardCreatorPrice = {
    price,
};
function price(productCartCreator) {
    const mainProductPrice = ProductInstancePrice.price(ProductInstancePrice.priceSelector(productCartCreator.productInstanceCreator.instance)).multiply(productCartCreator.quantity);
    return mainProductPrice.add(ProductCardCrossSellingCreatorPrice.price(productCartCreator.crossSellingCreator));
}
